import React, { Component } from 'react';

class CentroCostos extends Component {
    constructor(props){
        super(props)
        this.state={
            codigoArea:"",
            codigoSector:"",
        }
    }
    
    onInputChange(e){
        const { value, dataset } = e.target;
        const regExp = new RegExp(dataset.validation);
        if (regExp.test(value) || value.replace(/\s/g, "", "") == "") {
            let newState = {
                [dataset.code]: value
            }
            if (dataset.code == "codigoSectorCentroDeCostos") {
                this.props.changeInput(dataset.code, value)
            }
            if (dataset.code == "codigoAreaCentroDeCostos") {
                this.props.changeInput(dataset.code, value)
            }
            this.setState(newState);
        }  
    }
    render() {
        const {data}=this.props

        let errorSinArea = this.state.codigoArea == "" && this.state.codigoSector != ""

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <label className="label-primary">Centro de Costos</label>
                    <div className="row">
                        <div className="col-xs-2">
                            <label className="label-secondary">Area</label>
                        </div>
                        <div className="col-xs-3">
                       
                             <input 
                            className="form-control input-Short" 
                            type="text"
                            maxLength={3}
                            value={data.codigoAreaCentroDeCostos }
                            data-code="codigoAreaCentroDeCostos"
                            data-validation="^([1-9a-zA-Z]{1,3})$"
                            onChange={this.onInputChange.bind(this)}
                            />
                        </div>
                    </div>
                    <div className="row top-separator-xs"></div>
                    <div className="row">
                        <div className="col-xs-2">
                            <label className="label-secondary">Sector</label>
                        </div>
                        <div className="col-xs-3">
                        <input 
                            className="form-control input-Short" 
                            type="text"
                            maxLength={3}
                            value={data.codigoSectorCentroDeCostos }
                            data-code="codigoSectorCentroDeCostos"
                            data-validation="^([1-9a-zA-Z]{1,3})$"
                            onChange={this.onInputChange.bind(this)}
                            />
                        </div>
                        <div className="col-md-12">
                        {(data.ERROR_ADICIONAL["seleccionoCentroCostos"] == false && errorSinArea)
                            && <label className="error">{"Para agregar un Sector debe agregar también un Área."}</label>
                        }
                        </div>
                    </div>
                </div>
            </div>
     )
    }
};

export default CentroCostos;